import MailOutlineIcon from '@mui/icons-material/MailOutline';
import ReplayIcon from '@mui/icons-material/Replay';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import CircularProgress from '@mui/material/CircularProgress';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import Typography from '@mui/material/Typography';
import React, { useState } from 'react';
// @ts-ignore
// eslint-disable-next-line import/no-unresolved
import { useRegisterSW } from 'virtual:pwa-register/react';

import { secondsToDate } from '../../utils/date-utils';

interface AboutProps {
    onClose: () => void;
    translations: Record<string, string>;
}

export const About: React.FC<AboutProps> = ({ onClose, translations }) => {
    const version =
        import.meta.env.VITE_COMMIT_HASH?.length > 0 ? import.meta.env.VITE_COMMIT_HASH : import.meta.env.VITE_VERSION;
    const name = import.meta.env.VITE_NAME;
    const buildDate = secondsToDate(import.meta.env.VITE_BUILD_TIME);

    const { updateServiceWorker } = useRegisterSW();

    const feedbackAddress = 'adams-service@cern.ch';
    const subject = `Feedback from ${name}, version ${version}, build date ${buildDate}`;
    const mailtoLink = `mailto:${feedbackAddress}?subject=${encodeURI(subject)}`;

    const [updateInProgress, setUpdateInProgress] = useState(false);

    const handleUpdate = () => {
        setUpdateInProgress(true);
        navigator.serviceWorker.getRegistrations().then((registrations) => {
            const unregisterPromises = registrations.map((registration) => registration.unregister());
            Promise.all(unregisterPromises).then(() => {
                setTimeout(() => {
                    updateServiceWorker(true).then(() => {
                        setUpdateInProgress(false);
                        window.location.reload();
                    });
                }, 2000);
            });
        });
    };

    return (
        <Dialog
            open={true}
            onClose={onClose}
            aria-labelledby="about-alert-dialog"
            aria-describedby="alert-dialog-description"
        >
            <DialogTitle>
                {name} v{version}
            </DialogTitle>
            <DialogContent>
                <Box mb={2}>
                    <Button
                        disabled={updateInProgress}
                        fullWidth
                        variant="outlined"
                        size="large"
                        startIcon={updateInProgress ? <CircularProgress color="inherit" size={24} /> : <ReplayIcon />}
                        onClick={handleUpdate}
                    >
                        {updateInProgress ? translations.GLOBAL_CHECKING_BUTTON : translations.GLOBAL_UPDATE_BUTTON}
                    </Button>
                </Box>
                {/* put instructions about cache clearing */}
                <Box mb={2}>
                    <Button
                        fullWidth
                        variant="outlined"
                        size="large"
                        href={mailtoLink}
                        target="_blank"
                        rel="noopener noreferrer"
                        startIcon={<MailOutlineIcon />}
                    >
                        {translations.ABOUT_SEND_FEEDBACK_BUTTON}
                    </Button>
                </Box>
            </DialogContent>
            <Box sx={{ ml: 2 }}>
                <Typography variant="subtitle2">{buildDate}</Typography>
                <Typography variant="subtitle2">&copy; CERN</Typography>
            </Box>
            <DialogActions>
                <Button onClick={onClose} color="primary" size="large" aria-label="Close">
                    {translations.GLOBAL_CLOSE_BUTTON}
                </Button>
            </DialogActions>
        </Dialog>
    );
};
